(function (_, kotlin_io_ktor_ktor_client_logging, kotlin_kotlin, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_ktor_ktor_client_auth, kotlin_io_ktor_ktor_utils, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_kodein_di_kodein_di, kotlin_org_kodein_type_kodein_type, kotlin_com_taager_experience_data, kotlin_io_ktor_ktor_io) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Companion_getInstance = kotlin_io_ktor_ktor_client_logging.$_$.c;
  var get_DEFAULT = kotlin_io_ktor_ktor_client_logging.$_$.e;
  var Logger = kotlin_io_ktor_ktor_client_logging.$_$.f;
  var classMeta = kotlin_kotlin.$_$.v8;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.z;
  var defaultRequest = kotlin_io_ktor_ktor_client_core.$_$.o;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
  var Companion_getInstance_0 = kotlin_io_ktor_ktor_client_logging.$_$.d;
  var objectMeta = kotlin_kotlin.$_$.y9;
  var header = kotlin_io_ktor_ktor_client_core.$_$.u;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.k;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.h;
  var accept = kotlin_io_ktor_ktor_client_core.$_$.s;
  var json$default = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
  var Json$default = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var Plugin_getInstance_0 = kotlin_io_ktor_ktor_client_auth.$_$.a;
  var BearerTokens = kotlin_io_ktor_ktor_client_auth.$_$.b;
  var CoroutineImpl = kotlin_kotlin.$_$.g8;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.f4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.b3;
  var createFailure = kotlin_kotlin.$_$.hd;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.e3;
  var THROW_CCE = kotlin_kotlin.$_$.vc;
  var isObject = kotlin_kotlin.$_$.p9;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.d3;
  var RefreshTokensParams = kotlin_io_ktor_ktor_client_auth.$_$.c;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.r7;
  var bearer = kotlin_io_ktor_ktor_client_auth.$_$.d;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.q;
  var path = kotlin_io_ktor_ktor_http.$_$.p1;
  var JsType_getInstance = kotlin_io_ktor_ktor_utils.$_$.d;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.fd;
  var createKType = kotlin_kotlin.$_$.b;
  var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.w;
  var NullBody_getInstance = kotlin_io_ktor_ktor_http.$_$.g;
  var Companion_getInstance_2 = kotlin_io_ktor_ktor_http.$_$.l;
  var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.y;
  var SuspendFunction0 = kotlin_kotlin.$_$.h8;
  var SuspendFunction1 = kotlin_kotlin.$_$.i8;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var NotImplementedError = kotlin_kotlin.$_$.sc;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.pd;
  var LogLevel_ALL_getInstance = kotlin_io_ktor_ktor_client_logging.$_$.a;
  var Companion_getInstance_3 = kotlin_io_ktor_ktor_http.$_$.o;
  var LogLevel_NONE_getInstance = kotlin_io_ktor_ktor_client_logging.$_$.b;
  var interfaceMeta = kotlin_kotlin.$_$.e9;
  var THROW_ISE = kotlin_kotlin.$_$.wc;
  var Enum = kotlin_kotlin.$_$.lc;
  var Module_init_$Create$ = kotlin_org_kodein_di_kodein_di.$_$.a;
  var HttpClient_0 = kotlin_io_ktor_ktor_client_core.$_$.a1;
  var typeToken = kotlin_org_kodein_type_kodein_type.$_$.d;
  var TypeToken = kotlin_org_kodein_type_kodein_type.$_$.b;
  var isInterface = kotlin_kotlin.$_$.n9;
  var Singleton = kotlin_org_kodein_di_kodein_di.$_$.d;
  var Provider = kotlin_org_kodein_di_kodein_di.$_$.c;
  var Companion_getInstance_4 = kotlin_org_kodein_di_kodein_di.$_$.b;
  var Instance = kotlin_org_kodein_di_kodein_di.$_$.h;
  var get_diContext = kotlin_org_kodein_di_kodein_di.$_$.e;
  var get_diTrigger = kotlin_org_kodein_di_kodein_di.$_$.f;
  var DIAware = kotlin_org_kodein_di_kodein_di.$_$.g;
  var KProperty1 = kotlin_kotlin.$_$.qa;
  var getPropertyCallableRef = kotlin_kotlin.$_$.b9;
  var Companion_getInstance_5 = kotlin_io_ktor_ktor_client_core.$_$.d;
  var HttpRequest = kotlin_io_ktor_ktor_client_core.$_$.r;
  var General = kotlin_com_taager_experience_data.$_$.h;
  var Connection = kotlin_com_taager_experience_data.$_$.g;
  var IOException = kotlin_io_ktor_ktor_io.$_$.h1;
  var Server = kotlin_com_taager_experience_data.$_$.i;
  var ServerResponseException = kotlin_io_ktor_ktor_client_core.$_$.n;
  var ClientRequestException = kotlin_io_ktor_ktor_client_core.$_$.k;
  var isBlank = kotlin_kotlin.$_$.db;
  var General_0 = kotlin_com_taager_experience_data.$_$.d;
  var Conflict = kotlin_com_taager_experience_data.$_$.b;
  var Companion_getInstance_6 = kotlin_io_ktor_ktor_http.$_$.n;
  var NotFound = kotlin_com_taager_experience_data.$_$.e;
  var Forbidden = kotlin_com_taager_experience_data.$_$.c;
  var Unauthorized = kotlin_com_taager_experience_data.$_$.f;
  var BadRequest = kotlin_com_taager_experience_data.$_$.a;
  var bodyAsText$default = kotlin_io_ktor_ktor_client_core.$_$.a;
  var KProperty0 = kotlin_kotlin.$_$.pa;
  var SuspendFunction2 = kotlin_kotlin.$_$.j8;
  //endregion
  //region block: pre-declaration
  setupAuthentication$lambda$lambda$slambda.prototype = Object.create(CoroutineImpl.prototype);
  setupAuthentication$lambda$lambda$slambda.prototype.constructor = setupAuthentication$lambda$lambda$slambda;
  setupAuthentication$lambda$lambda$slambda_1.prototype = Object.create(CoroutineImpl.prototype);
  setupAuthentication$lambda$lambda$slambda_1.prototype.constructor = setupAuthentication$lambda$lambda$slambda_1;
  $refreshTokenCOROUTINE$0.prototype = Object.create(CoroutineImpl.prototype);
  $refreshTokenCOROUTINE$0.prototype.constructor = $refreshTokenCOROUTINE$0;
  ApiDomain.prototype = Object.create(Enum.prototype);
  ApiDomain.prototype.constructor = ApiDomain;
  setupExceptionHandler$lambda$slambda.prototype = Object.create(CoroutineImpl.prototype);
  setupExceptionHandler$lambda$slambda.prototype.constructor = setupExceptionHandler$lambda$slambda;
  $toApiExceptionCOROUTINE$1.prototype = Object.create(CoroutineImpl.prototype);
  $toApiExceptionCOROUTINE$1.prototype.constructor = $toApiExceptionCOROUTINE$1;
  $toClientApiExceptionCOROUTINE$2.prototype = Object.create(CoroutineImpl.prototype);
  $toClientApiExceptionCOROUTINE$2.prototype.constructor = $toClientApiExceptionCOROUTINE$2;
  $toApiErrorCOROUTINE$3.prototype = Object.create(CoroutineImpl.prototype);
  $toApiErrorCOROUTINE$3.prototype.constructor = $toApiErrorCOROUTINE$3;
  //endregion
  function ApiMonitor(apiLogMonitor, apiExceptionMonitor) {
    this.m4t_1 = apiLogMonitor;
    this.n4t_1 = apiExceptionMonitor;
    this.o4t_1 = get_DEFAULT(Companion_getInstance());
  }
  ApiMonitor.prototype.onException = function (cause) {
    this.n4t_1.onException(cause);
  };
  ApiMonitor.prototype.v4f = function (message) {
    this.o4t_1.v4f(message);
    this.m4t_1.onLog(message);
  };
  ApiMonitor.$metadata$ = classMeta('ApiMonitor', [Logger]);
  function HttpClientProvider$provide$lambda(this$0) {
    return function ($this$HttpClient) {
      $this$HttpClient.j39_1 = true;
      setupDefaultRequest($this$HttpClient, this$0.q4t_1, this$0.p4t_1, this$0.r4t_1);
      setupJson($this$HttpClient);
      setupLogging($this$HttpClient, this$0.q4t_1, this$0.t4t_1);
      setupAuthentication($this$HttpClient, this$0.s4t_1);
      setupExceptionHandler($this$HttpClient, this$0.t4t_1);
      return Unit_getInstance();
    };
  }
  function HttpClientProvider(appInfo, apiConfig, configurationHandler, authenticationHandler, apiMonitor) {
    this.p4t_1 = appInfo;
    this.q4t_1 = apiConfig;
    this.r4t_1 = configurationHandler;
    this.s4t_1 = authenticationHandler;
    this.t4t_1 = apiMonitor;
  }
  HttpClientProvider.prototype.u4t = function () {
    return HttpClient(HttpClientProvider$provide$lambda(this));
  };
  HttpClientProvider.$metadata$ = classMeta('HttpClientProvider');
  function get_jsonParser() {
    init_properties_HttpClientSetup_kt_525xw6();
    return jsonParser;
  }
  var jsonParser;
  function setupDefaultRequest(_this__u8e3s4, apiConfig, appInfo, configurationHandler) {
    init_properties_HttpClientSetup_kt_525xw6();
    defaultRequest(_this__u8e3s4, setupDefaultRequest$lambda(appInfo, configurationHandler, apiConfig));
  }
  function setupJson(_this__u8e3s4) {
    init_properties_HttpClientSetup_kt_525xw6();
    var tmp = Plugin_getInstance();
    _this__u8e3s4.e3a(tmp, setupJson$lambda);
  }
  function setupLogging(_this__u8e3s4, apiConfig, apiMonitor) {
    init_properties_HttpClientSetup_kt_525xw6();
    var tmp = Companion_getInstance_0();
    _this__u8e3s4.e3a(tmp, setupLogging$lambda(apiMonitor, apiConfig));
  }
  function ApiHeaders() {
    ApiHeaders_instance = this;
    this.v4t_1 = 'platform';
    this.w4t_1 = 'version';
    this.x4t_1 = 'ui-session-key';
    this.y4t_1 = 'country';
  }
  ApiHeaders.$metadata$ = objectMeta('ApiHeaders');
  var ApiHeaders_instance;
  function ApiHeaders_getInstance() {
    if (ApiHeaders_instance == null)
      new ApiHeaders();
    return ApiHeaders_instance;
  }
  function jsonParser$lambda($this$Json) {
    init_properties_HttpClientSetup_kt_525xw6();
    $this$Json.v2x_1 = true;
    $this$Json.w2x_1 = false;
    $this$Json.x2x_1 = true;
    $this$Json.y2x_1 = true;
    $this$Json.a2y_1 = true;
    return Unit_getInstance();
  }
  function setupDefaultRequest$lambda$lambda($apiConfig) {
    return function ($this$url) {
      $this$url.l27_1 = $apiConfig.p28();
      $this$url.m27_1 = $apiConfig.q28();
      $this$url.n27_1 = $apiConfig.s28();
      return Unit_getInstance();
    };
  }
  function setupDefaultRequest$lambda($appInfo, $configurationHandler, $apiConfig) {
    return function ($this$defaultRequest) {
      $this$defaultRequest.x3h(setupDefaultRequest$lambda$lambda($apiConfig));
      ApiHeaders_getInstance();
      header($this$defaultRequest, 'platform', get_platform($appInfo));
      ApiHeaders_getInstance();
      header($this$defaultRequest, 'version', $appInfo.a4u_1);
      ApiHeaders_getInstance();
      header($this$defaultRequest, 'ui-session-key', $configurationHandler.provideSessionId());
      var tmp;
      ApiHeaders_getInstance();
      if (!$this$defaultRequest.q3h_1.a1u('country')) {
        ApiHeaders_getInstance();
        header($this$defaultRequest, 'country', $configurationHandler.provideCountryId());
        tmp = Unit_getInstance();
      }
      header($this$defaultRequest, HttpHeaders_getInstance().q20_1, Application_getInstance().i1y_1);
      accept($this$defaultRequest, Application_getInstance().i1y_1);
      return Unit_getInstance();
    };
  }
  function setupJson$lambda($this$install) {
    init_properties_HttpClientSetup_kt_525xw6();
    var tmp = get_jsonParser();
    json$default($this$install, tmp, null, 2, null);
    return Unit_getInstance();
  }
  function setupLogging$lambda($apiMonitor, $apiConfig) {
    return function ($this$install) {
      $this$install.j4h_1 = $apiMonitor;
      $this$install.k4h_1 = $apiConfig.b4u();
      return Unit_getInstance();
    };
  }
  var properties_initialized_HttpClientSetup_kt_dfcgai;
  function init_properties_HttpClientSetup_kt_525xw6() {
    if (properties_initialized_HttpClientSetup_kt_dfcgai) {
    } else {
      properties_initialized_HttpClientSetup_kt_dfcgai = true;
      jsonParser = Json$default(null, jsonParser$lambda, 1, null);
    }
  }
  function AuthenticationHandler(accessTokenProvider, accessTokenUpdater) {
    this.c4u_1 = accessTokenProvider;
    this.d4u_1 = accessTokenUpdater;
  }
  AuthenticationHandler.prototype.provideTokens = function () {
    return this.c4u_1.provideTokens();
  };
  AuthenticationHandler.prototype.updateTokens = function (accessTokens) {
    this.d4u_1.updateTokens(accessTokens);
  };
  AuthenticationHandler.$metadata$ = classMeta('AuthenticationHandler');
  function setupAuthentication(_this__u8e3s4, authenticationHandler) {
    var tmp = Plugin_getInstance_0();
    _this__u8e3s4.e3a(tmp, setupAuthentication$lambda(authenticationHandler));
  }
  function asBearerTokens(_this__u8e3s4) {
    return new BearerTokens(_this__u8e3s4.e4u_1, _this__u8e3s4.f4u_1);
  }
  function refreshToken(_this__u8e3s4, client, refreshToken, $cont) {
    var tmp = new $refreshTokenCOROUTINE$0(_this__u8e3s4, client, refreshToken, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  }
  function setupAuthentication$lambda$lambda$slambda($authenticationHandler, resultContinuation) {
    this.b4v_1 = $authenticationHandler;
    CoroutineImpl.call(this, resultContinuation);
  }
  setupAuthentication$lambda$lambda$slambda.prototype.r4b = function ($cont) {
    var tmp = this.q4a($cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  setupAuthentication$lambda$lambda$slambda.prototype.sk = function ($cont) {
    return this.r4b($cont);
  };
  setupAuthentication$lambda$lambda$slambda.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        if (tmp === 0) {
          this.lj_1 = 1;
          var tmp_0;
          try {
            var tmp0_success = Companion_getInstance_1();
            var tmp0_safe_receiver = this.b4v_1.provideTokens();
            var tmp1_success = tmp0_safe_receiver == null ? null : asBearerTokens(tmp0_safe_receiver);
            tmp_0 = _Result___init__impl__xyqfz8(tmp1_success);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
              var tmp2_failure = Companion_getInstance_1();
              tmp_1 = _Result___init__impl__xyqfz8(createFailure($p));
            } else {
              throw $p;
            }
            tmp_0 = tmp_1;
          }
          var tmp0_getOrNull = tmp_0;
          var tmp_2;
          if (_Result___get_isFailure__impl__jpiriv(tmp0_getOrNull)) {
            tmp_2 = null;
          } else {
            var tmp_3 = _Result___get_value__impl__bjfvqg(tmp0_getOrNull);
            tmp_2 = (tmp_3 == null ? true : isObject(tmp_3)) ? tmp_3 : THROW_CCE();
          }
          return tmp_2;
        } else if (tmp === 1) {
          throw this.nj_1;
        }
      } catch ($p) {
        throw $p;
      }
     while (true);
  };
  setupAuthentication$lambda$lambda$slambda.prototype.q4a = function (completion) {
    var i = new setupAuthentication$lambda$lambda$slambda(this.b4v_1, completion);
    return i;
  };
  setupAuthentication$lambda$lambda$slambda.$metadata$ = classMeta('setupAuthentication$lambda$lambda$slambda', undefined, undefined, undefined, [0], CoroutineImpl.prototype);
  function setupAuthentication$lambda$lambda$slambda_0($authenticationHandler, resultContinuation) {
    var i = new setupAuthentication$lambda$lambda$slambda($authenticationHandler, resultContinuation);
    var l = function ($cont) {
      return i.r4b($cont);
    };
    l.$arity = 0;
    return l;
  }
  function setupAuthentication$lambda$lambda$slambda_1($authenticationHandler, resultContinuation) {
    this.k4v_1 = $authenticationHandler;
    CoroutineImpl.call(this, resultContinuation);
  }
  setupAuthentication$lambda$lambda$slambda_1.prototype.q4v = function ($this$refreshTokens, $cont) {
    var tmp = this.g4a($this$refreshTokens, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  setupAuthentication$lambda$lambda$slambda_1.prototype.uj = function (p1, $cont) {
    return this.q4v(p1 instanceof RefreshTokensParams ? p1 : THROW_CCE(), $cont);
  };
  setupAuthentication$lambda$lambda$slambda_1.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 4;
            this.lj_1 = 3;
            var tmp_0 = this;
            tmp_0.n4v_1 = Companion_getInstance_1();
            this.o4v_1 = this.l4v_1.b4b_1;
            if (this.o4v_1 == null) {
              this.p4v_1 = null;
              this.kj_1 = 2;
              continue $sm;
            } else {
              this.kj_1 = 1;
              suspendResult = refreshToken(this.l4v_1, this.l4v_1.z4a_1, this.o4v_1.y4a_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

            break;
          case 1:
            var newAccessToken = suspendResult;
            var accessTokens = new AccessTokens(newAccessToken, this.o4v_1.y4a_1);
            this.k4v_1.updateTokens(accessTokens);
            this.p4v_1 = asBearerTokens(accessTokens);
            this.kj_1 = 2;
            continue $sm;
          case 2:
            var tmp1_success = this.p4v_1;
            this.m4v_1 = _Result___init__impl__xyqfz8(tmp1_success);
            this.lj_1 = 4;
            this.kj_1 = 5;
            continue $sm;
          case 3:
            this.lj_1 = 4;
            var tmp_1 = this.nj_1;
            if (tmp_1 instanceof Error) {
              var e = this.nj_1;
              var tmp_2 = this;
              var tmp2_failure = Companion_getInstance_1();
              tmp_2.m4v_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.kj_1 = 5;
              continue $sm;
            } else {
              throw this.nj_1;
            }

            break;
          case 4:
            throw this.nj_1;
          case 5:
            this.lj_1 = 4;
            var tmp0_getOrNull = this.m4v_1;
            var tmp_3;
            if (_Result___get_isFailure__impl__jpiriv(tmp0_getOrNull)) {
              tmp_3 = null;
            } else {
              var tmp_4 = _Result___get_value__impl__bjfvqg(tmp0_getOrNull);
              tmp_3 = (tmp_4 == null ? true : isObject(tmp_4)) ? tmp_4 : THROW_CCE();
            }

            return tmp_3;
        }
      } catch ($p) {
        if (this.lj_1 === 4) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  setupAuthentication$lambda$lambda$slambda_1.prototype.g4a = function ($this$refreshTokens, completion) {
    var i = new setupAuthentication$lambda$lambda$slambda_1(this.k4v_1, completion);
    i.l4v_1 = $this$refreshTokens;
    return i;
  };
  setupAuthentication$lambda$lambda$slambda_1.$metadata$ = classMeta('setupAuthentication$lambda$lambda$slambda', undefined, undefined, undefined, [1], CoroutineImpl.prototype);
  function setupAuthentication$lambda$lambda$slambda_2($authenticationHandler, resultContinuation) {
    var i = new setupAuthentication$lambda$lambda$slambda_1($authenticationHandler, resultContinuation);
    var l = function ($this$refreshTokens, $cont) {
      return i.q4v($this$refreshTokens, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function setupAuthentication$lambda$lambda($authenticationHandler) {
    return function ($this$bearer) {
      $this$bearer.w4a(setupAuthentication$lambda$lambda$slambda_0($authenticationHandler, null));
      $this$bearer.v4a(setupAuthentication$lambda$lambda$slambda_2($authenticationHandler, null));
      return Unit_getInstance();
    };
  }
  function setupAuthentication$lambda($authenticationHandler) {
    return function ($this$install) {
      bearer($this$install, setupAuthentication$lambda$lambda($authenticationHandler));
      return Unit_getInstance();
    };
  }
  function $refreshTokenCOROUTINE$0(_this__u8e3s4, client, refreshToken, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o4u_1 = _this__u8e3s4;
    this.p4u_1 = client;
    this.q4u_1 = refreshToken;
  }
  $refreshTokenCOROUTINE$0.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 3;
            var tmp_0 = this;
            var tmp0_apply = new HttpRequestBuilder();
            this.o4u_1.c4b(tmp0_apply);
            path(tmp0_apply.x38_1, ['/api/users/refresh-token']);
            var tmp0_setBody = new RefreshTokenRequest(this.q4u_1);
            var tmp0_subject = tmp0_setBody;
            if (tmp0_subject == null) {
              tmp0_apply.a39_1 = NullBody_getInstance();
              var tmp_1 = JsType_getInstance();
              var tmp_2 = getKClass(RefreshTokenRequest);
              var tmp_3;
              try {
                tmp_3 = createKType(getKClass(RefreshTokenRequest), arrayOf([]), false);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  tmp_4 = null;
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              tmp0_apply.x3e(typeInfoImpl(tmp_1, tmp_2, tmp_3));
            } else {
              if (tmp0_subject instanceof OutgoingContent) {
                tmp0_apply.a39_1 = tmp0_setBody;
                tmp0_apply.x3e(null);
              } else {
                tmp0_apply.a39_1 = tmp0_setBody;
                var tmp_5 = JsType_getInstance();
                var tmp_6 = getKClass(RefreshTokenRequest);
                var tmp_7;
                try {
                  tmp_7 = createKType(getKClass(RefreshTokenRequest), arrayOf([]), false);
                } catch ($p) {
                  var tmp_8;
                  if ($p instanceof Error) {
                    tmp_8 = null;
                  } else {
                    throw $p;
                  }
                  tmp_7 = tmp_8;
                }
                tmp0_apply.x3e(typeInfoImpl(tmp_5, tmp_6, tmp_7));
              }
            }

            tmp_0.r4u_1 = tmp0_apply;
            this.r4u_1.y38_1 = Companion_getInstance_2().h24_1;
            this.kj_1 = 1;
            suspendResult = (new HttpStatement(this.r4u_1, this.p4u_1)).r41(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.s4u_1 = suspendResult;
            this.kj_1 = 2;
            var tmp_9 = this.s4u_1.e3c();
            var tmp_10 = JsType_getInstance();
            var tmp_11 = getKClass(RefreshTokenResponse);
            var tmp_12;
            try {
              tmp_12 = createKType(getKClass(RefreshTokenResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_13;
              if ($p instanceof Error) {
                tmp_13 = null;
              } else {
                throw $p;
              }
              tmp_12 = tmp_13;
            }

            suspendResult = tmp_9.i3b(typeInfoImpl(tmp_10, tmp_11, tmp_12), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult instanceof RefreshTokenResponse ? suspendResult : THROW_CCE();
            return ARGUMENT.r4v_1;
          case 3:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 3) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $refreshTokenCOROUTINE$0.$metadata$ = classMeta('$refreshTokenCOROUTINE$0', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function AccessTokens(accessToken, refreshToken) {
    this.e4u_1 = accessToken;
    this.f4u_1 = refreshToken;
  }
  AccessTokens.prototype.s4v = function () {
    return this.e4u_1;
  };
  AccessTokens.prototype.t4v = function () {
    return this.f4u_1;
  };
  AccessTokens.prototype.component1 = function () {
    return this.e4u_1;
  };
  AccessTokens.prototype.component2 = function () {
    return this.f4u_1;
  };
  AccessTokens.prototype.copy = function (accessToken, refreshToken) {
    return this.al(accessToken === void 1 ? this.e4u_1 : accessToken, refreshToken === void 1 ? this.f4u_1 : refreshToken);
  };
  AccessTokens.prototype.al = function (accessToken, refreshToken) {
    return new AccessTokens(accessToken, refreshToken);
  };
  AccessTokens.prototype.bl = function (accessToken, refreshToken, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      accessToken = this.e4u_1;
    if (!(($mask0 & 2) === 0))
      refreshToken = this.f4u_1;
    return this.al(accessToken, refreshToken);
  };
  AccessTokens.prototype.toString = function () {
    return 'AccessTokens(accessToken=' + this.e4u_1 + ', refreshToken=' + this.f4u_1 + ')';
  };
  AccessTokens.prototype.hashCode = function () {
    var result = getStringHashCode(this.e4u_1);
    result = imul(result, 31) + getStringHashCode(this.f4u_1) | 0;
    return result;
  };
  AccessTokens.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccessTokens))
      return false;
    var tmp0_other_with_cast = other instanceof AccessTokens ? other : THROW_CCE();
    if (!(this.e4u_1 === tmp0_other_with_cast.e4u_1))
      return false;
    if (!(this.f4u_1 === tmp0_other_with_cast.f4u_1))
      return false;
    return true;
  };
  AccessTokens.$metadata$ = classMeta('AccessTokens');
  Object.defineProperty(AccessTokens.prototype, 'accessToken', {
    configurable: true,
    get: AccessTokens.prototype.s4v
  });
  Object.defineProperty(AccessTokens.prototype, 'refreshToken', {
    configurable: true,
    get: AccessTokens.prototype.t4v
  });
  function Companion() {
    Companion_instance = this;
  }
  Companion.$metadata$ = objectMeta('Companion');
  var Companion_instance;
  function Companion_getInstance_7() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.taager.experience.api.authentication.model.RefreshTokenRequest', this, 1);
    tmp0_serialDesc.s2n('refreshToken', false);
    this.u4v_1 = tmp0_serialDesc;
  }
  $serializer.prototype.g2e = function () {
    return this.u4v_1;
  };
  $serializer.prototype.u2n = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [StringSerializer_getInstance()];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  $serializer.prototype.i2e = function (decoder) {
    var tmp0_desc = this.u4v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.c2h(tmp0_desc);
    if (tmp5_input.p2h()) {
      tmp4_local0 = tmp5_input.m2h(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.q2h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.m2h(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.d2h(tmp0_desc);
    return RefreshTokenRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  $serializer.prototype.v4v = function (encoder, value) {
    var tmp0_desc = this.u4v_1;
    var tmp1_output = encoder.c2h(tmp0_desc);
    tmp1_output.n2i(tmp0_desc, 0, value.w4v_1);
    tmp1_output.d2h(tmp0_desc);
  };
  $serializer.prototype.h2e = function (encoder, value) {
    return this.v4v(encoder, value instanceof RefreshTokenRequest ? value : THROW_CCE());
  };
  $serializer.$metadata$ = objectMeta('$serializer', [GeneratedSerializer]);
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function RefreshTokenRequest_init_$Init$(seen1, refreshToken, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance().u4v_1);
    }
    $this.w4v_1 = refreshToken;
    return $this;
  }
  function RefreshTokenRequest_init_$Create$(seen1, refreshToken, serializationConstructorMarker) {
    return RefreshTokenRequest_init_$Init$(seen1, refreshToken, serializationConstructorMarker, Object.create(RefreshTokenRequest.prototype));
  }
  function RefreshTokenRequest(refreshToken) {
    Companion_getInstance_7();
    this.w4v_1 = refreshToken;
  }
  RefreshTokenRequest.prototype.toString = function () {
    return 'RefreshTokenRequest(refreshToken=' + this.w4v_1 + ')';
  };
  RefreshTokenRequest.prototype.hashCode = function () {
    return getStringHashCode(this.w4v_1);
  };
  RefreshTokenRequest.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefreshTokenRequest))
      return false;
    var tmp0_other_with_cast = other instanceof RefreshTokenRequest ? other : THROW_CCE();
    if (!(this.w4v_1 === tmp0_other_with_cast.w4v_1))
      return false;
    return true;
  };
  RefreshTokenRequest.$metadata$ = classMeta('RefreshTokenRequest', undefined, undefined, {0: $serializer_getInstance});
  function Companion_0() {
    Companion_instance_0 = this;
  }
  Companion_0.$metadata$ = objectMeta('Companion');
  var Companion_instance_0;
  function Companion_getInstance_8() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.taager.experience.api.authentication.model.RefreshTokenResponse', this, 1);
    tmp0_serialDesc.s2n('accessToken', false);
    this.x4v_1 = tmp0_serialDesc;
  }
  $serializer_0.prototype.g2e = function () {
    return this.x4v_1;
  };
  $serializer_0.prototype.u2n = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [StringSerializer_getInstance()];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  $serializer_0.prototype.i2e = function (decoder) {
    var tmp0_desc = this.x4v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.c2h(tmp0_desc);
    if (tmp5_input.p2h()) {
      tmp4_local0 = tmp5_input.m2h(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.q2h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.m2h(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.d2h(tmp0_desc);
    return RefreshTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  $serializer_0.prototype.y4v = function (encoder, value) {
    var tmp0_desc = this.x4v_1;
    var tmp1_output = encoder.c2h(tmp0_desc);
    tmp1_output.n2i(tmp0_desc, 0, value.r4v_1);
    tmp1_output.d2h(tmp0_desc);
  };
  $serializer_0.prototype.h2e = function (encoder, value) {
    return this.y4v(encoder, value instanceof RefreshTokenResponse ? value : THROW_CCE());
  };
  $serializer_0.$metadata$ = objectMeta('$serializer', [GeneratedSerializer]);
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function RefreshTokenResponse_init_$Init$(seen1, accessToken, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_0().x4v_1);
    }
    $this.r4v_1 = accessToken;
    return $this;
  }
  function RefreshTokenResponse_init_$Create$(seen1, accessToken, serializationConstructorMarker) {
    return RefreshTokenResponse_init_$Init$(seen1, accessToken, serializationConstructorMarker, Object.create(RefreshTokenResponse.prototype));
  }
  function RefreshTokenResponse(accessToken) {
    Companion_getInstance_8();
    this.r4v_1 = accessToken;
  }
  RefreshTokenResponse.prototype.toString = function () {
    return 'RefreshTokenResponse(accessToken=' + this.r4v_1 + ')';
  };
  RefreshTokenResponse.prototype.hashCode = function () {
    return getStringHashCode(this.r4v_1);
  };
  RefreshTokenResponse.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefreshTokenResponse))
      return false;
    var tmp0_other_with_cast = other instanceof RefreshTokenResponse ? other : THROW_CCE();
    if (!(this.r4v_1 === tmp0_other_with_cast.r4v_1))
      return false;
    return true;
  };
  RefreshTokenResponse.$metadata$ = classMeta('RefreshTokenResponse', undefined, undefined, {0: $serializer_getInstance_0});
  function provideApiConfig(apiDomain, isDevelopmentMode) {
    var tmp0_subject = apiDomain;
    var tmp0 = tmp0_subject.d5_1;
    var tmp;
    switch (tmp0) {
      case 0:
        throw new NotImplementedError('An operation is not implemented: Not implemented');
      case 1:
        var tmp_0;
        if (isDevelopmentMode) {
          tmp_0 = Development_getInstance();
        } else {
          tmp_0 = Production_getInstance();
        }

        tmp = tmp_0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function ConfigurationHandler(sessionIdProvider, countryIdProvider) {
    this.z4v_1 = sessionIdProvider;
    this.a4w_1 = countryIdProvider;
  }
  ConfigurationHandler.prototype.provideSessionId = function () {
    return this.z4v_1.provideSessionId();
  };
  ConfigurationHandler.prototype.provideCountryId = function () {
    return this.a4w_1.provideCountryId();
  };
  ConfigurationHandler.$metadata$ = classMeta('ConfigurationHandler');
  function Development() {
    Development_instance = this;
    this.b4w_1 = LogLevel_ALL_getInstance();
    this.c4w_1 = 'merchant.api.dev.taager.com';
    this.d4w_1 = 0;
    this.e4w_1 = Companion_getInstance_3().g27_1;
  }
  Development.prototype.b4u = function () {
    return this.b4w_1;
  };
  Development.prototype.q28 = function () {
    return this.c4w_1;
  };
  Development.prototype.s28 = function () {
    return this.d4w_1;
  };
  Development.prototype.p28 = function () {
    return this.e4w_1;
  };
  Development.$metadata$ = objectMeta('Development', [ApiConfig]);
  var Development_instance;
  function Development_getInstance() {
    if (Development_instance == null)
      new Development();
    return Development_instance;
  }
  function Production() {
    Production_instance = this;
    this.f4w_1 = LogLevel_NONE_getInstance();
    this.g4w_1 = 'merchant.api.taager.com';
    this.h4w_1 = 0;
    this.i4w_1 = Companion_getInstance_3().g27_1;
  }
  Production.prototype.b4u = function () {
    return this.f4w_1;
  };
  Production.prototype.q28 = function () {
    return this.g4w_1;
  };
  Production.prototype.s28 = function () {
    return this.h4w_1;
  };
  Production.prototype.p28 = function () {
    return this.i4w_1;
  };
  Production.$metadata$ = objectMeta('Production', [ApiConfig]);
  var Production_instance;
  function Production_getInstance() {
    if (Production_instance == null)
      new Production();
    return Production_instance;
  }
  function ApiConfig() {
  }
  ApiConfig.$metadata$ = interfaceMeta('ApiConfig');
  var ApiDomain_Admin_instance;
  var ApiDomain_Merchant_instance;
  function values() {
    return [ApiDomain_Admin_getInstance(), ApiDomain_Merchant_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Admin':
        return ApiDomain_Admin_getInstance();
      case 'Merchant':
        return ApiDomain_Merchant_getInstance();
      default:
        ApiDomain_initEntries();
        THROW_ISE();
        break;
    }
  }
  var ApiDomain_entriesInitialized;
  function ApiDomain_initEntries() {
    if (ApiDomain_entriesInitialized)
      return Unit_getInstance();
    ApiDomain_entriesInitialized = true;
    ApiDomain_Admin_instance = new ApiDomain('Admin', 0);
    ApiDomain_Merchant_instance = new ApiDomain('Merchant', 1);
  }
  function ApiDomain(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ApiDomain.$metadata$ = classMeta('ApiDomain', undefined, undefined, undefined, undefined, Enum.prototype);
  Object.defineProperty(ApiDomain.prototype, 'name', {
    configurable: true,
    get: ApiDomain.prototype.ji
  });
  Object.defineProperty(ApiDomain.prototype, 'ordinal', {
    configurable: true,
    get: ApiDomain.prototype.ki
  });
  function ApiDomain_Admin_getInstance() {
    ApiDomain_initEntries();
    return ApiDomain_Admin_instance;
  }
  function ApiDomain_Merchant_getInstance() {
    ApiDomain_initEntries();
    return ApiDomain_Merchant_instance;
  }
  function AppInfo(isDevelopmentMode, version) {
    this.z4t_1 = isDevelopmentMode;
    this.a4u_1 = version;
  }
  AppInfo.prototype.l4w = function () {
    return this.z4t_1;
  };
  AppInfo.prototype.p3c = function () {
    return this.a4u_1;
  };
  AppInfo.prototype.component1 = function () {
    return this.z4t_1;
  };
  AppInfo.prototype.component2 = function () {
    return this.a4u_1;
  };
  AppInfo.prototype.copy = function (isDevelopmentMode, version) {
    return this.m4w(isDevelopmentMode === void 1 ? this.z4t_1 : isDevelopmentMode, version === void 1 ? this.a4u_1 : version);
  };
  AppInfo.prototype.m4w = function (isDevelopmentMode, version) {
    return new AppInfo(isDevelopmentMode, version);
  };
  AppInfo.prototype.n4w = function (isDevelopmentMode, version, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      isDevelopmentMode = this.z4t_1;
    if (!(($mask0 & 2) === 0))
      version = this.a4u_1;
    return this.m4w(isDevelopmentMode, version);
  };
  AppInfo.prototype.toString = function () {
    return 'AppInfo(isDevelopmentMode=' + this.z4t_1 + ', version=' + this.a4u_1 + ')';
  };
  AppInfo.prototype.hashCode = function () {
    var result = this.z4t_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.a4u_1) | 0;
    return result;
  };
  AppInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AppInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AppInfo ? other : THROW_CCE();
    if (!(this.z4t_1 === tmp0_other_with_cast.z4t_1))
      return false;
    if (!(this.a4u_1 === tmp0_other_with_cast.a4u_1))
      return false;
    return true;
  };
  AppInfo.$metadata$ = classMeta('AppInfo');
  Object.defineProperty(AppInfo.prototype, 'isDevelopmentMode', {
    configurable: true,
    get: AppInfo.prototype.l4w
  });
  Object.defineProperty(AppInfo.prototype, 'version', {
    configurable: true,
    get: AppInfo.prototype.p3c
  });
  function ApiDI$module$lambda($this$$receiver) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = values();
    var indexedObject = tmp0_forEach;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      setup($this$$receiver, element);
    }
    return Unit_getInstance();
  }
  function ApiDI() {
    ApiDI_instance = this;
    var tmp = this;
    tmp.o4w_1 = Module_init_$Create$('API DI', false, null, ApiDI$module$lambda, 6, null);
  }
  ApiDI.$metadata$ = objectMeta('ApiDI');
  var ApiDI_instance;
  function ApiDI_getInstance() {
    if (ApiDI_instance == null)
      new ApiDI();
    return ApiDI_instance;
  }
  function setup(_this__u8e3s4, apiDomain) {
    var tmp$ret$2;
    // Inline function 'org.kodein.di.bindSingleton' call
    var tmp0_bindSingleton = setup$lambda(apiDomain);
    var tmp$ret$1;
    // Inline function 'org.kodein.di.singleton' call
    var tmp = _this__u8e3s4.l4n();
    var tmp_0 = _this__u8e3s4.m4n();
    var tmp_1 = _this__u8e3s4.n4n();
    var tmp$ret$0;
    // Inline function 'org.kodein.type.generic' call
    var tmp_2 = typeToken(createKType(getKClass(HttpClient_0), arrayOf([]), false));
    tmp$ret$0 = isInterface(tmp_2, TypeToken) ? tmp_2 : THROW_CCE();
    tmp$ret$1 = new Singleton(tmp, tmp_0, tmp_1, tmp$ret$0, null, true, tmp0_bindSingleton);
    _this__u8e3s4.u4n(apiDomain, null, tmp$ret$1);
    tmp$ret$2 = Unit_getInstance();
    var tmp$ret$5;
    // Inline function 'org.kodein.di.bindProvider' call
    var tmp1_bindProvider = setup$lambda_0(apiDomain);
    var tmp$ret$4;
    // Inline function 'org.kodein.di.provider' call
    var tmp_3 = _this__u8e3s4.m4n();
    var tmp$ret$3;
    // Inline function 'org.kodein.type.generic' call
    var tmp_4 = typeToken(createKType(getKClass(HttpClientProvider), arrayOf([]), false));
    tmp$ret$3 = isInterface(tmp_4, TypeToken) ? tmp_4 : THROW_CCE();
    tmp$ret$4 = new Provider(tmp_3, tmp$ret$3, tmp1_bindProvider);
    _this__u8e3s4.u4n(apiDomain, null, tmp$ret$4);
    tmp$ret$5 = Unit_getInstance();
    var tmp$ret$8;
    // Inline function 'org.kodein.di.bindProvider' call
    var tmp2_bindProvider = setup$lambda_1(apiDomain);
    var tmp$ret$7;
    // Inline function 'org.kodein.di.provider' call
    var tmp_5 = _this__u8e3s4.m4n();
    var tmp$ret$6;
    // Inline function 'org.kodein.type.generic' call
    var tmp_6 = typeToken(createKType(getKClass(ApiConfig), arrayOf([]), false));
    tmp$ret$6 = isInterface(tmp_6, TypeToken) ? tmp_6 : THROW_CCE();
    tmp$ret$7 = new Provider(tmp_5, tmp$ret$6, tmp2_bindProvider);
    _this__u8e3s4.u4n(apiDomain, null, tmp$ret$7);
    tmp$ret$8 = Unit_getInstance();
  }
  function setup$lambda($apiDomain) {
    return function ($this$bindSingleton) {
      var tmp$ret$1;
      // Inline function 'org.kodein.di.instance' call
      var tmp = $this$bindSingleton.b4p();
      var tmp$ret$0;
      // Inline function 'org.kodein.type.generic' call
      var tmp_0 = typeToken(createKType(getKClass(HttpClientProvider), arrayOf([]), false));
      tmp$ret$0 = isInterface(tmp_0, TypeToken) ? tmp_0 : THROW_CCE();
      tmp$ret$1 = tmp.i4p(tmp$ret$0, $apiDomain);
      return tmp$ret$1.u4t();
    };
  }
  function setup$lambda_0($apiDomain) {
    return function ($this$bindProvider) {
      var tmp$ret$1;
      // Inline function 'org.kodein.di.instance' call
      var tmp = $this$bindProvider.b4p();
      var tmp$ret$0;
      // Inline function 'org.kodein.type.generic' call
      var tmp_0 = typeToken(createKType(getKClass(AppInfo), arrayOf([]), false));
      tmp$ret$0 = isInterface(tmp_0, TypeToken) ? tmp_0 : THROW_CCE();
      tmp$ret$1 = tmp.i4p(tmp$ret$0, null);
      var tmp_1 = tmp$ret$1;
      var tmp$ret$3;
      // Inline function 'org.kodein.di.instance' call
      var tmp_2 = $this$bindProvider.b4p();
      var tmp$ret$2;
      // Inline function 'org.kodein.type.generic' call
      var tmp_3 = typeToken(createKType(getKClass(ApiConfig), arrayOf([]), false));
      tmp$ret$2 = isInterface(tmp_3, TypeToken) ? tmp_3 : THROW_CCE();
      tmp$ret$3 = tmp_2.i4p(tmp$ret$2, $apiDomain);
      var tmp_4 = tmp$ret$3;
      var tmp$ret$5;
      // Inline function 'org.kodein.di.instance' call
      var tmp_5 = $this$bindProvider.b4p();
      var tmp$ret$4;
      // Inline function 'org.kodein.type.generic' call
      var tmp_6 = typeToken(createKType(getKClass(ConfigurationHandler), arrayOf([]), false));
      tmp$ret$4 = isInterface(tmp_6, TypeToken) ? tmp_6 : THROW_CCE();
      tmp$ret$5 = tmp_5.i4p(tmp$ret$4, null);
      var tmp_7 = tmp$ret$5;
      var tmp$ret$7;
      // Inline function 'org.kodein.di.instance' call
      var tmp_8 = $this$bindProvider.b4p();
      var tmp$ret$6;
      // Inline function 'org.kodein.type.generic' call
      var tmp_9 = typeToken(createKType(getKClass(AuthenticationHandler), arrayOf([]), false));
      tmp$ret$6 = isInterface(tmp_9, TypeToken) ? tmp_9 : THROW_CCE();
      tmp$ret$7 = tmp_8.i4p(tmp$ret$6, null);
      var tmp_10 = tmp$ret$7;
      var tmp$ret$9;
      // Inline function 'org.kodein.di.instance' call
      var tmp_11 = $this$bindProvider.b4p();
      var tmp$ret$8;
      // Inline function 'org.kodein.type.generic' call
      var tmp_12 = typeToken(createKType(getKClass(ApiMonitor), arrayOf([]), false));
      tmp$ret$8 = isInterface(tmp_12, TypeToken) ? tmp_12 : THROW_CCE();
      tmp$ret$9 = tmp_11.i4p(tmp$ret$8, null);
      return new HttpClientProvider(tmp_1, tmp_4, tmp_7, tmp_10, tmp$ret$9);
    };
  }
  function setup$lambda_1($apiDomain) {
    return function ($this$bindProvider) {
      var tmp$ret$1;
      // Inline function 'org.kodein.di.instance' call
      var tmp = $this$bindProvider.b4p();
      var tmp$ret$0;
      // Inline function 'org.kodein.type.generic' call
      var tmp_0 = typeToken(createKType(getKClass(AppInfo), arrayOf([]), false));
      tmp$ret$0 = isInterface(tmp_0, TypeToken) ? tmp_0 : THROW_CCE();
      tmp$ret$1 = tmp.i4p(tmp$ret$0, null);
      return provideApiConfig($apiDomain, tmp$ret$1.z4t_1);
    };
  }
  function ApiInjector$di$delegate$lambda$lambda(this$0) {
    return function ($this$bindSingleton) {
      return this$0.p4w_1;
    };
  }
  function ApiInjector$di$delegate$lambda$lambda_0($sessionIdProvider, $countryIdProvider) {
    return function ($this$bindSingleton) {
      return new ConfigurationHandler($sessionIdProvider, $countryIdProvider);
    };
  }
  function ApiInjector$di$delegate$lambda$lambda_1($accessTokenProvider, $accessTokenUpdater) {
    return function ($this$bindSingleton) {
      return new AuthenticationHandler($accessTokenProvider, $accessTokenUpdater);
    };
  }
  function ApiInjector$di$delegate$lambda$lambda_2($apiLogMonitor, $apiExceptionMonitor) {
    return function ($this$bindSingleton) {
      return new ApiMonitor($apiLogMonitor, $apiExceptionMonitor);
    };
  }
  function ApiInjector$di$delegate$lambda(this$0, $sessionIdProvider, $countryIdProvider, $accessTokenProvider, $accessTokenUpdater, $apiLogMonitor, $apiExceptionMonitor) {
    return function ($this$lazy) {
      var tmp = ApiDI_getInstance().o4w_1;
      $this$lazy.w4n(tmp, false, 2, null);
      var tmp$ret$2;
      // Inline function 'org.kodein.di.bindSingleton' call
      var tmp0_bindSingleton = ApiInjector$di$delegate$lambda$lambda(this$0);
      var tmp$ret$1;
      // Inline function 'org.kodein.di.singleton' call
      var tmp_0 = $this$lazy.l4n();
      var tmp_1 = $this$lazy.m4n();
      var tmp_2 = $this$lazy.n4n();
      var tmp$ret$0;
      // Inline function 'org.kodein.type.generic' call
      var tmp_3 = typeToken(createKType(getKClass(AppInfo), arrayOf([]), false));
      tmp$ret$0 = isInterface(tmp_3, TypeToken) ? tmp_3 : THROW_CCE();
      tmp$ret$1 = new Singleton(tmp_0, tmp_1, tmp_2, tmp$ret$0, null, true, tmp0_bindSingleton);
      $this$lazy.u4n(null, null, tmp$ret$1);
      tmp$ret$2 = Unit_getInstance();
      var tmp$ret$5;
      // Inline function 'org.kodein.di.bindSingleton' call
      var tmp1_bindSingleton = ApiInjector$di$delegate$lambda$lambda_0($sessionIdProvider, $countryIdProvider);
      var tmp$ret$4;
      // Inline function 'org.kodein.di.singleton' call
      var tmp_4 = $this$lazy.l4n();
      var tmp_5 = $this$lazy.m4n();
      var tmp_6 = $this$lazy.n4n();
      var tmp$ret$3;
      // Inline function 'org.kodein.type.generic' call
      var tmp_7 = typeToken(createKType(getKClass(ConfigurationHandler), arrayOf([]), false));
      tmp$ret$3 = isInterface(tmp_7, TypeToken) ? tmp_7 : THROW_CCE();
      tmp$ret$4 = new Singleton(tmp_4, tmp_5, tmp_6, tmp$ret$3, null, true, tmp1_bindSingleton);
      $this$lazy.u4n(null, null, tmp$ret$4);
      tmp$ret$5 = Unit_getInstance();
      var tmp$ret$8;
      // Inline function 'org.kodein.di.bindSingleton' call
      var tmp2_bindSingleton = ApiInjector$di$delegate$lambda$lambda_1($accessTokenProvider, $accessTokenUpdater);
      var tmp$ret$7;
      // Inline function 'org.kodein.di.singleton' call
      var tmp_8 = $this$lazy.l4n();
      var tmp_9 = $this$lazy.m4n();
      var tmp_10 = $this$lazy.n4n();
      var tmp$ret$6;
      // Inline function 'org.kodein.type.generic' call
      var tmp_11 = typeToken(createKType(getKClass(AuthenticationHandler), arrayOf([]), false));
      tmp$ret$6 = isInterface(tmp_11, TypeToken) ? tmp_11 : THROW_CCE();
      tmp$ret$7 = new Singleton(tmp_8, tmp_9, tmp_10, tmp$ret$6, null, true, tmp2_bindSingleton);
      $this$lazy.u4n(null, null, tmp$ret$7);
      tmp$ret$8 = Unit_getInstance();
      var tmp$ret$11;
      // Inline function 'org.kodein.di.bindSingleton' call
      var tmp3_bindSingleton = ApiInjector$di$delegate$lambda$lambda_2($apiLogMonitor, $apiExceptionMonitor);
      var tmp$ret$10;
      // Inline function 'org.kodein.di.singleton' call
      var tmp_12 = $this$lazy.l4n();
      var tmp_13 = $this$lazy.m4n();
      var tmp_14 = $this$lazy.n4n();
      var tmp$ret$9;
      // Inline function 'org.kodein.type.generic' call
      var tmp_15 = typeToken(createKType(getKClass(ApiMonitor), arrayOf([]), false));
      tmp$ret$9 = isInterface(tmp_15, TypeToken) ? tmp_15 : THROW_CCE();
      tmp$ret$10 = new Singleton(tmp_12, tmp_13, tmp_14, tmp$ret$9, null, true, tmp3_bindSingleton);
      $this$lazy.u4n(null, null, tmp$ret$10);
      tmp$ret$11 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function ApiInjector(appInfo, apiDomain, sessionIdProvider, countryIdProvider, accessTokenProvider, accessTokenUpdater, apiLogMonitor, apiExceptionMonitor) {
    this.p4w_1 = appInfo;
    var tmp = this;
    var tmp_0 = Companion_getInstance_4();
    tmp.q4w_1 = tmp_0.e4o(false, ApiInjector$di$delegate$lambda(this, sessionIdProvider, countryIdProvider, accessTokenProvider, accessTokenUpdater, apiLogMonitor, apiExceptionMonitor), 1, null);
    var tmp_1 = this;
    var tmp$ret$1;
    // Inline function 'org.kodein.di.instance' call
    var tmp$ret$0;
    // Inline function 'org.kodein.type.generic' call
    var tmp_2 = typeToken(createKType(getKClass(HttpClient_0), arrayOf([]), false));
    tmp$ret$0 = isInterface(tmp_2, TypeToken) ? tmp_2 : THROW_CCE();
    tmp$ret$1 = Instance(this, tmp$ret$0, apiDomain);
    tmp_1.r4w_1 = tmp$ret$1.k4t(this, client$factory());
  }
  ApiInjector.prototype.f4o = function () {
    return this.q4w_1.bn(this, di$factory());
  };
  ApiInjector.prototype.p41 = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = client$factory_0();
    tmp$ret$0 = this.r4w_1.x();
    return tmp$ret$0;
  };
  ApiInjector.$metadata$ = classMeta('ApiInjector', [DIAware]);
  Object.defineProperty(ApiInjector.prototype, 'client', {
    configurable: true,
    get: ApiInjector.prototype.p41
  });
  function client$factory() {
    return getPropertyCallableRef('client', 1, KProperty1, function (receiver) {
      return receiver.client;
    }, null);
  }
  function di$factory() {
    return getPropertyCallableRef('di', 1, KProperty1, function (receiver) {
      return receiver.f4o();
    }, null);
  }
  function client$factory_0() {
    return getPropertyCallableRef('client', 1, KProperty1, function (receiver) {
      return receiver.client;
    }, null);
  }
  function setupExceptionHandler(_this__u8e3s4, apiMonitor) {
    var tmp = Companion_getInstance_5();
    _this__u8e3s4.e3a(tmp, setupExceptionHandler$lambda(apiMonitor));
  }
  function toApiException(_this__u8e3s4, $cont) {
    var tmp = new $toApiExceptionCOROUTINE$1(_this__u8e3s4, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  }
  function toClientApiException(_this__u8e3s4, $cont) {
    var tmp = new $toClientApiExceptionCOROUTINE$2(_this__u8e3s4, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  }
  function toApiError(_this__u8e3s4, $cont) {
    var tmp = new $toApiErrorCOROUTINE$3(_this__u8e3s4, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  }
  function setupExceptionHandler$lambda$slambda($apiMonitor, resultContinuation) {
    this.f4y_1 = $apiMonitor;
    CoroutineImpl.call(this, resultContinuation);
  }
  setupExceptionHandler$lambda$slambda.prototype.i4y = function (cause, _anonymous_parameter_1__qggqgd, $cont) {
    var tmp = this.j4y(cause, _anonymous_parameter_1__qggqgd, $cont);
    tmp.mj_1 = Unit_getInstance();
    tmp.nj_1 = null;
    return tmp.tj();
  };
  setupExceptionHandler$lambda$slambda.prototype.g8 = function (p1, p2, $cont) {
    var tmp = p1 instanceof Error ? p1 : THROW_CCE();
    return this.i4y(tmp, (!(p2 == null) ? isInterface(p2, HttpRequest) : false) ? p2 : THROW_CCE(), $cont);
  };
  setupExceptionHandler$lambda$slambda.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 2;
            this.kj_1 = 1;
            suspendResult = toApiException(this.g4y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var apiException = suspendResult;
            this.f4y_1.onException(apiException);
            throw apiException;
          case 2:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 2) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  setupExceptionHandler$lambda$slambda.prototype.j4y = function (cause, _anonymous_parameter_1__qggqgd, completion) {
    var i = new setupExceptionHandler$lambda$slambda(this.f4y_1, completion);
    i.g4y_1 = cause;
    i.h4y_1 = _anonymous_parameter_1__qggqgd;
    return i;
  };
  setupExceptionHandler$lambda$slambda.$metadata$ = classMeta('setupExceptionHandler$lambda$slambda', undefined, undefined, undefined, [2], CoroutineImpl.prototype);
  function setupExceptionHandler$lambda$slambda_0($apiMonitor, resultContinuation) {
    var i = new setupExceptionHandler$lambda$slambda($apiMonitor, resultContinuation);
    var l = function (cause, _anonymous_parameter_1__qggqgd, $cont) {
      return i.i4y(cause, _anonymous_parameter_1__qggqgd, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function setupExceptionHandler$lambda($apiMonitor) {
    return function ($this$install) {
      $this$install.a3o(setupExceptionHandler$lambda$slambda_0($apiMonitor, null));
      return Unit_getInstance();
    };
  }
  function $toApiExceptionCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a4x_1 = _this__u8e3s4;
  }
  $toApiExceptionCOROUTINE$1.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 3;
            this.b4x_1 = this.a4x_1;
            var tmp_0 = this.b4x_1;
            if (tmp_0 instanceof ClientRequestException) {
              this.kj_1 = 1;
              suspendResult = toClientApiException(this.a4x_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.b4x_1;
              if (tmp_1 instanceof ServerResponseException) {
                this.c4x_1 = new Server(this.a4x_1.d3i_1);
                this.kj_1 = 2;
                continue $sm;
              } else {
                var tmp_2 = this.b4x_1;
                if (tmp_2 instanceof IOException) {
                  this.c4x_1 = new Connection(this.a4x_1.message);
                  this.kj_1 = 2;
                  continue $sm;
                } else {
                  this.c4x_1 = new General(this.a4x_1.message);
                  this.kj_1 = 2;
                  continue $sm;
                }
              }
            }

            break;
          case 1:
            this.c4x_1 = suspendResult;
            this.kj_1 = 2;
            continue $sm;
          case 2:
            return this.c4x_1;
          case 3:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 3) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $toApiExceptionCOROUTINE$1.$metadata$ = classMeta('$toApiExceptionCOROUTINE$1', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function $toClientApiExceptionCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l4x_1 = _this__u8e3s4;
  }
  $toClientApiExceptionCOROUTINE$2.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 2;
            this.kj_1 = 1;
            suspendResult = toApiError(this.l4x_1.e3i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var apiError = suspendResult;
            var tmp0_ifBlank = apiError.k4y_1;
            var tmp1_ifBlank = errorCode$factory(apiError);
            var errorCode = isBlank(tmp0_ifBlank) ? tmp1_ifBlank() : tmp0_ifBlank;
            var statusCode = this.l4x_1.e3i_1.h2a();
            return statusCode.equals(Companion_getInstance_6().r25_1) ? new BadRequest(errorCode, this.l4x_1.b3i_1) : statusCode.equals(Companion_getInstance_6().s25_1) ? new Unauthorized(errorCode, this.l4x_1.b3i_1) : statusCode.equals(Companion_getInstance_6().u25_1) ? new Forbidden(errorCode, this.l4x_1.b3i_1) : statusCode.equals(Companion_getInstance_6().v25_1) ? new NotFound(errorCode, this.l4x_1.b3i_1) : statusCode.equals(Companion_getInstance_6().a26_1) ? new Conflict(errorCode, this.l4x_1.b3i_1) : new General_0(statusCode.z26_1, this.l4x_1.b3i_1);
          case 2:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 2) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $toClientApiExceptionCOROUTINE$2.$metadata$ = classMeta('$toClientApiExceptionCOROUTINE$2', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function $toApiErrorCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u4x_1 = _this__u8e3s4;
  }
  $toApiErrorCOROUTINE$3.prototype.tj = function () {
    var suspendResult = this.mj_1;
    $sm: do
      try {
        var tmp = this.kj_1;
        switch (tmp) {
          case 0:
            this.lj_1 = 5;
            this.lj_1 = 2;
            this.kj_1 = 1;
            var tmp_0 = this.u4x_1.e3c();
            var tmp_1 = JsType_getInstance();
            var tmp_2 = getKClass(ApiError);
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(ApiError), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }

            suspendResult = tmp_0.i3b(typeInfoImpl(tmp_1, tmp_2, tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_5 = this;
            tmp_5.v4x_1 = suspendResult instanceof ApiError ? suspendResult : THROW_CCE();
            this.lj_1 = 5;
            this.kj_1 = 4;
            continue $sm;
          case 2:
            this.lj_1 = 5;
            var tmp_6 = this.nj_1;
            if (tmp_6 instanceof Error) {
              this.w4x_1 = this.nj_1;
              this.kj_1 = 3;
              suspendResult = bodyAsText$default(this.u4x_1, null, this, 1, null);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.nj_1;
            }

            break;
          case 3:
            var ARGUMENT = suspendResult;
            var tmp_7 = this;
            tmp_7.v4x_1 = ApiError_init_$Create$(null, null, null, null, ARGUMENT, 15, null);
            this.kj_1 = 4;
            continue $sm;
          case 4:
            this.lj_1 = 5;
            return this.v4x_1;
          case 5:
            throw this.nj_1;
        }
      } catch ($p) {
        if (this.lj_1 === 5) {
          throw $p;
        } else {
          this.kj_1 = this.lj_1;
          this.nj_1 = $p;
        }
      }
     while (true);
  };
  $toApiErrorCOROUTINE$3.$metadata$ = classMeta('$toApiErrorCOROUTINE$3', undefined, undefined, undefined, undefined, CoroutineImpl.prototype);
  function errorCode$factory($b0) {
    return getPropertyCallableRef('errorCode', 0, KProperty0, function () {
      return $b0.l4y_1;
    }, null);
  }
  function ApiError_init_$Init$(code, errorCode, description, msg, message, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      code = '';
    if (!(($mask0 & 2) === 0))
      errorCode = '';
    if (!(($mask0 & 4) === 0))
      description = '';
    if (!(($mask0 & 8) === 0))
      msg = '';
    if (!(($mask0 & 16) === 0))
      message = '';
    ApiError.call($this, code, errorCode, description, msg, message);
    return $this;
  }
  function ApiError_init_$Create$(code, errorCode, description, msg, message, $mask0, $marker) {
    return ApiError_init_$Init$(code, errorCode, description, msg, message, $mask0, $marker, Object.create(ApiError.prototype));
  }
  function Companion_1() {
    Companion_instance_1 = this;
  }
  Companion_1.$metadata$ = objectMeta('Companion');
  var Companion_instance_1;
  function Companion_getInstance_9() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.taager.experience.api.exception.model.ApiError', this, 5);
    tmp0_serialDesc.s2n('code', true);
    tmp0_serialDesc.s2n('errorCode', true);
    tmp0_serialDesc.s2n('description', true);
    tmp0_serialDesc.s2n('msg', true);
    tmp0_serialDesc.s2n('message', true);
    this.p4y_1 = tmp0_serialDesc;
  }
  $serializer_1.prototype.g2e = function () {
    return this.p4y_1;
  };
  $serializer_1.prototype.u2n = function () {
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
  $serializer_1.prototype.i2e = function (decoder) {
    var tmp0_desc = this.p4y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.c2h(tmp0_desc);
    if (tmp9_input.p2h()) {
      tmp4_local0 = tmp9_input.m2h(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.m2h(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.m2h(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.m2h(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.m2h(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.q2h(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.m2h(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.m2h(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.m2h(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.m2h(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.m2h(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.d2h(tmp0_desc);
    return ApiError_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  $serializer_1.prototype.q4y = function (encoder, value) {
    var tmp0_desc = this.p4y_1;
    var tmp1_output = encoder.c2h(tmp0_desc);
    if (tmp1_output.s2i(tmp0_desc, 0) ? true : !(value.k4y_1 === '')) {
      tmp1_output.n2i(tmp0_desc, 0, value.k4y_1);
    }
    if (tmp1_output.s2i(tmp0_desc, 1) ? true : !(value.l4y_1 === '')) {
      tmp1_output.n2i(tmp0_desc, 1, value.l4y_1);
    }
    if (tmp1_output.s2i(tmp0_desc, 2) ? true : !(value.m4y_1 === '')) {
      tmp1_output.n2i(tmp0_desc, 2, value.m4y_1);
    }
    if (tmp1_output.s2i(tmp0_desc, 3) ? true : !(value.n4y_1 === '')) {
      tmp1_output.n2i(tmp0_desc, 3, value.n4y_1);
    }
    if (tmp1_output.s2i(tmp0_desc, 4) ? true : !(value.o4y_1 === '')) {
      tmp1_output.n2i(tmp0_desc, 4, value.o4y_1);
    }
    tmp1_output.d2h(tmp0_desc);
  };
  $serializer_1.prototype.h2e = function (encoder, value) {
    return this.q4y(encoder, value instanceof ApiError ? value : THROW_CCE());
  };
  $serializer_1.$metadata$ = objectMeta('$serializer', [GeneratedSerializer]);
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function ApiError_init_$Init$_0(seen1, code, errorCode, description, msg, message, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen1))) {
      throwMissingFieldException(seen1, 0, $serializer_getInstance_1().p4y_1);
    }
    if (0 === (seen1 & 1))
      $this.k4y_1 = '';
    else
      $this.k4y_1 = code;
    if (0 === (seen1 & 2))
      $this.l4y_1 = '';
    else
      $this.l4y_1 = errorCode;
    if (0 === (seen1 & 4))
      $this.m4y_1 = '';
    else
      $this.m4y_1 = description;
    if (0 === (seen1 & 8))
      $this.n4y_1 = '';
    else
      $this.n4y_1 = msg;
    if (0 === (seen1 & 16))
      $this.o4y_1 = '';
    else
      $this.o4y_1 = message;
    return $this;
  }
  function ApiError_init_$Create$_0(seen1, code, errorCode, description, msg, message, serializationConstructorMarker) {
    return ApiError_init_$Init$_0(seen1, code, errorCode, description, msg, message, serializationConstructorMarker, Object.create(ApiError.prototype));
  }
  function ApiError(code, errorCode, description, msg, message) {
    Companion_getInstance_9();
    this.k4y_1 = code;
    this.l4y_1 = errorCode;
    this.m4y_1 = description;
    this.n4y_1 = msg;
    this.o4y_1 = message;
  }
  ApiError.prototype.toString = function () {
    return 'ApiError(code=' + this.k4y_1 + ', errorCode=' + this.l4y_1 + ', description=' + this.m4y_1 + ', msg=' + this.n4y_1 + ', message=' + this.o4y_1 + ')';
  };
  ApiError.prototype.hashCode = function () {
    var result = getStringHashCode(this.k4y_1);
    result = imul(result, 31) + getStringHashCode(this.l4y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m4y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n4y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o4y_1) | 0;
    return result;
  };
  ApiError.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ApiError))
      return false;
    var tmp0_other_with_cast = other instanceof ApiError ? other : THROW_CCE();
    if (!(this.k4y_1 === tmp0_other_with_cast.k4y_1))
      return false;
    if (!(this.l4y_1 === tmp0_other_with_cast.l4y_1))
      return false;
    if (!(this.m4y_1 === tmp0_other_with_cast.m4y_1))
      return false;
    if (!(this.n4y_1 === tmp0_other_with_cast.n4y_1))
      return false;
    if (!(this.o4y_1 === tmp0_other_with_cast.o4y_1))
      return false;
    return true;
  };
  ApiError.$metadata$ = classMeta('ApiError', undefined, undefined, {0: $serializer_getInstance_1});
  function get_platform(_this__u8e3s4) {
    return 'web';
  }
  //region block: post-declaration
  $serializer.prototype.v2n = typeParametersSerializers;
  $serializer_0.prototype.v2n = typeParametersSerializers;
  ApiInjector.prototype.h4o = get_diContext;
  ApiInjector.prototype.i4o = get_diTrigger;
  $serializer_1.prototype.v2n = typeParametersSerializers;
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$authentication = $com$taager$experience$api.authentication || ($com$taager$experience$api.authentication = {});
    var $com$taager$experience$api$authentication$model = $com$taager$experience$api$authentication.model || ($com$taager$experience$api$authentication.model = {});
    $com$taager$experience$api$authentication$model.AccessTokens = AccessTokens;
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$configuration = $com$taager$experience$api.configuration || ($com$taager$experience$api.configuration = {});
    var $com$taager$experience$api$configuration$model = $com$taager$experience$api$configuration.model || ($com$taager$experience$api$configuration.model = {});
    $com$taager$experience$api$configuration$model.ApiDomain = ApiDomain;
    $com$taager$experience$api$configuration$model.ApiDomain.values = values;
    $com$taager$experience$api$configuration$model.ApiDomain.valueOf = valueOf;
    Object.defineProperty($com$taager$experience$api$configuration$model.ApiDomain, 'Admin', {
      configurable: true,
      get: ApiDomain_Admin_getInstance
    });
    Object.defineProperty($com$taager$experience$api$configuration$model.ApiDomain, 'Merchant', {
      configurable: true,
      get: ApiDomain_Merchant_getInstance
    });
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$configuration = $com$taager$experience$api.configuration || ($com$taager$experience$api.configuration = {});
    var $com$taager$experience$api$configuration$model = $com$taager$experience$api$configuration.model || ($com$taager$experience$api$configuration.model = {});
    $com$taager$experience$api$configuration$model.AppInfo = AppInfo;
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$di = $com$taager$experience$api.di || ($com$taager$experience$api.di = {});
    $com$taager$experience$api$di.ApiInjector = ApiInjector;
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$authentication = $com$taager$experience$api.authentication || ($com$taager$experience$api.authentication = {});
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$authentication = $com$taager$experience$api.authentication || ($com$taager$experience$api.authentication = {});
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$configuration = $com$taager$experience$api.configuration || ($com$taager$experience$api.configuration = {});
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$configuration = $com$taager$experience$api.configuration || ($com$taager$experience$api.configuration = {});
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$exception = $com$taager$experience$api.exception || ($com$taager$experience$api.exception = {});
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$api = $com$taager$experience.api || ($com$taager$experience.api = {});
    var $com$taager$experience$api$logging = $com$taager$experience$api.logging || ($com$taager$experience$api.logging = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}(module.exports, require('./ktor-ktor-client-logging-js-ir.js'), require('./kotlin-kotlin-stdlib-js-ir.js'), require('./ktor-ktor-client-core-js-ir.js'), require('./ktor-ktor-client-content-negotiation-js-ir.js'), require('./ktor-ktor-http-js-ir.js'), require('./ktor-ktor-serialization-kotlinx-json-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-json-js-ir.js'), require('./ktor-ktor-client-auth-js-ir.js'), require('./ktor-ktor-utils-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-core-js-ir.js'), require('./Kodein-DI-kodein-di-js-ir.js'), require('./Kodein-Type-kodein-type-js-ir.js'), require('./shared-experience-data.js'), require('./ktor-ktor-io-js-ir.js')));

